import { render, staticRenderFns } from "./addNoticeViewList.vue?vue&type=template&id=bf74c36a&scoped=true"
import script from "./addNoticeViewList.vue?vue&type=script&lang=js"
export * from "./addNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./addNoticeViewList.vue?vue&type=style&index=0&id=bf74c36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf74c36a",
  null
  
)

export default component.exports